<template>
  <el-dialog
    title="提示"
    :visible.sync="showLogin"
    width="270px"
    custom-class="loginDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="dialog-body">
      <div class="d-header">
        <fm-button
          @click="handleClose"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <div class="d-content">
        <!-- <div class="title">{{ tips }}</div> -->
        <div class="loginBt" @click="handleLogin">
          <img
            class="feemooIcon"
            :src="$utils.getPng0('icon-gfans-feemoo')"
            alt=""
          />
          <span class="title2">Feemoo快捷登录</span>
        </div>
      </div>
      <!-- <div class="d-content">
        <div class="title">{{ tips }}</div>
      </div> -->
      <!-- <div class="d-footer">
        <fm-button @click="handleLogin" type="primary" size="small"
          >立即登录/注册</fm-button
        >
      </div> -->
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
export default {
  name: 'loginShow',
  props: {
    tips: {
      type: String,
      default: '通过Feemoo授权登录/注册',
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapState(['showLogin']),
  },
  methods: {
    //提交方法
    handleLogin: _.debounce(
      function () {
        setTimeout(() => {
          if (this.$store.state.showLoginInvite == '') {
            let path = this.$route.path.toString().slice(1)
            const from = 'daren'
            const fromUrl = this.$glb.darenUrl + `/${path}`
            const encodedFrom = encodeURIComponent(from)
            const encodedFromUrl = encodeURIComponent(fromUrl)
            window.location.href =
              this.$glb.fmpUrl +
              `/login?from=${encodedFrom}&fromUrl=${encodedFromUrl}`
          } else {
            window.location.href = this.$store.state.showLoginInvite
          }
        }, 200)
        this.handleClose()
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    handleClose() {
      this.$store.commit('setShowLogin', false)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .loginDialog {
  width: 480px !important;
  .el-dialog__body {
    padding: 20px 24px 32px 24px;
  }
  .d-header {
    .left {
      display: flex;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }
  .d-content {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 56px 0 28px 0;
    .title {
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #2c2c2c;
    }
    .loginBt {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f67942;
      border-radius: 26px;
      width: 324px;
      height: 52px;
      cursor: pointer;
      &:hover {
        background: #ff9c71;
      }
      &:active {
        background: #d84f13;
      }
      .feemooIcon {
        width: 40px;
        height: 40px;
        object-fit: cover;
      }
      .title2 {
        font-weight: 600;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
      }
    }
  }
  .d-footer {
    justify-content: center;
    button {
      width: 164px;
      height: 36px;
      margin-left: 0 !important;
    }
  }
}
</style>
